"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoCall/Modals/MoreOptionsMenu.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);







const MoreMenuOption = ({
  iconSrc, title, onClick,
}) => (
  _react2.default.createElement('div', { className: "video-call--more-option", onClick: onClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 12}}
    , _react2.default.createElement('img', {
      src: iconSrc,
      className: "video-call--more-option--icon",
      alt: "", __self: this, __source: {fileName: _jsxFileName, lineNumber: 13}}
    )
    , _react2.default.createElement('span', { className: "video-call--more-option--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 18}}, title)
  )
)










// The defaults were `defaultProps`; the classic JSX runtime the web build uses
// still applied them, so the parameter defaults keep the same values.
const MoreOptionsMenu = ({
  onClose,
  onRoomLinkCopy,
  onOpenSettings, onOpenNetstats,
  isSettingsLinkEnabled = true, isNetstatsLinkEnabled = false,
}) => (
  _react2.default.createElement(_react2.default.Fragment, null
    , _react2.default.createElement('h3', { className: "video-call--more--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}, "Choose an option..."  )
    , _react2.default.createElement('div', { className: "video-call--more--list", __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}}
      , _react2.default.createElement(MoreMenuOption, {
        iconSrc: "/assets/icons/video/link-black.svg",
        title: "Copy meeting link"  ,
        onClick: () => { onClose(); onRoomLinkCopy() }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}}
      )
      ,  isSettingsLinkEnabled &&
        _react2.default.createElement(MoreMenuOption, {
          iconSrc: "/assets/icons/video/settings.svg",
          title: "Check audio/video settings"  ,
          // Unset callbacks threw when clicked, as in JS.
          onClick: () => { onClose(); onOpenSettings() }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 48}}
        )
      
      ,  isNetstatsLinkEnabled &&
        _react2.default.createElement(MoreMenuOption, {
          iconSrc: "/assets/icons/video/network-black.svg",
          title: "Get network stats"  ,
          onClick: () => { onClose(); onOpenNetstats() }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}
        )
      
    )
  )
)

exports. default = MoreOptionsMenu
